export const GET_FAVORITOS_REF = "GET_FAVORITOS_REF";
export const GET_FAVORITOS_REF_SUCCESS = "GET_FAVORITOS_REF_SUCCESS";
export const GET_FAVORITOS_REF_ERROR = "GET_FAVORITOS_REF_ERROR";
export const ADD_FAVORITES_REF = "ADD_FAVORITES_REF";
export const ADD_FAVORITES_REF_SUCESS = "ADD_FAVORITES_REF_SUCESS";
export const ADD_FAVORITES_REF_ERROR = "ADD_FAVORITES_REF_ERROR";
export const EDIT_FAVORITES_REF_ERROR = "EDIT_FAVORITES_REF_ERROR";
export const DELETE_FAVORITES_REF = "DELETE_FAVORITES_REF";
export const DELETE_FAVORITES_REF_SUCESS = "DELETE_FAVORITES_REF_SUCESS";
export const DELETE_FAVORITES_REF_ERROR = "DELETE_FAVORITES_REF_ERROR";
export const GET_MESSAGES_FAVORITES_SERVICES = "GET_MESSAGES_FAVORITES_SERVICES";
export const GET_MESSAGES_FAVORITES_SERVICES_SUCCESS = "GET_MESSAGES_FAVORITES_SERVICES_SUCCESS";
export const GET_MESSAGES_FAVORITES_SERVICES_ERROR = "GET_MESSAGES_FAVORITES_SERVICES_ERROR";
export const CREATE_TOOLTIP_FAVORITE_SUCCESS = "CREATE_TOOLTIP_FAVORITE_SUCCESS";
export const CREATE_TOOLTIP_FAVORITE_ERROR = "CREATE_TOOLTIP_FAVORITE_ERROR";
export const GET_TOOLTIP_FAVORITE_SUCCESS = "GET_TOOLTIP_FAVORITE_SUCCESS";
export const GET_TOOLTIP_FAVORITE_ERROR = "GET_TOOLTIP_FAVORITE_ERROR";
export const GET_TOOLTIP_FAVORITE = "GET_TOOLTIP_FAVORITE";
export const CREATE_TOOLTIP_FAVORITE = "CREATE_TOOLTIP_FAVORITE";


export const getFavoritosRef = (reference, serviceId) => {
  return  {
    type: GET_FAVORITOS_REF,
    reference,
    serviceId,
  }
};

export const getFavoritosRefSuccess = (
  ResponseSuccess
) => ({
  type: GET_FAVORITOS_REF_SUCCESS,
  ResponseSuccess,
});

export const getFavoritosRefError = (error) => ({
  type: GET_FAVORITOS_REF_ERROR,
  ResponseError: error,
});

export const addFavoritesRef = (contact, serviceId) => ({
    type: ADD_FAVORITES_REF,
    contact,
    serviceId,
  });
  
  export const addFavoritesRefSucess = (ResponseSuccess) => ({
    type: ADD_FAVORITES_REF_SUCESS,
    ResponseSuccess
  });
  
  export const addFavoritesRefError = (err) => ({
    type: ADD_FAVORITES_REF_ERROR,
    ResponseError: err,
  });

  export const editFavoritesRefError = (err) => ({
    type: EDIT_FAVORITES_REF_ERROR,
    ResponseError: err,
  });
  
  export const deleteFavoritesRef = (lidFavorite) => {
    return{
      type: DELETE_FAVORITES_REF,
      lidFavorite,
    }
  };

  export const deleteFavoritesRefSucess = (ResponseSuccess) => ({
    type: DELETE_FAVORITES_REF_SUCESS,
    ResponseSuccess
  });
  
  export const deleteFavoritesRefError = (err) => ({
    type: DELETE_FAVORITES_REF_ERROR,
    ResponseError: err,
  });

  export const createTooltipFavorite = (lidApp) => {
    return{
      type: CREATE_TOOLTIP_FAVORITE,
      lidApp,
    }
  };

  export const createTooltipFavoriteSucess = (ResponseSuccess) => ({
    type: CREATE_TOOLTIP_FAVORITE_SUCCESS,
    ResponseSuccess
  });
  
  export const createTooltipFavoriteError = (err) => ({
    type: CREATE_TOOLTIP_FAVORITE_ERROR,
    ResponseError: err,
  });

  export const getTooltipFavorite = (lidApp) => {
    return{
      type: GET_TOOLTIP_FAVORITE,
      lidApp,
    }
  };

  export const getTooltipFavoriteSucess = (ResponseSuccess) => ({
    type: GET_TOOLTIP_FAVORITE_SUCCESS,
    ResponseSuccess
  });
  
  export const getTooltipFavoriteError = (err) => ({
    type: GET_TOOLTIP_FAVORITE_ERROR,
    ResponseError: err,
  });

  export const getMessagesFavoritesServices =(flux,code) => ({
    type: GET_MESSAGES_FAVORITES_SERVICES,
    flux,
    code,
  });

  export const getMessagesFavoritesServicesSuccess = (favoriteServicesMessages) => ({
    type: GET_MESSAGES_FAVORITES_SERVICES_SUCCESS,
    favoriteServicesMessages
  });
  
  export const getMessagesFavoritesServicessError = (e) => ({
    type: GET_MESSAGES_FAVORITES_SERVICES_ERROR,
    error: e.error
  });